module.exports = __webpack_public_path__ + "img/addplus.74d214c4.svg";